export const EmployeeTypesEnum = {
  staff: { label: 'Staff', value: 'STAFF' },
  nonStaff: { label: 'Non-staff', value: 'NON_STAFF' },
};
